// src/components/IpfsGatewayLoader.tsx
// Fetches the IPFS gateway URL from the backend tenant record and stores it in the singleton.
// Mount this inside ApolloProvider so it runs on app startup.

import { useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import { setIpfsGatewayUrl } from "../utils/ipfsConfig";

const GET_TENANT_IPFS_CONFIG = gql`
  query GetTenantIpfsConfig {
    currentTenant {
      id
      apiKeys {
        ipfsGatewayUrl
      }
    }
  }
`;

export const IpfsGatewayLoader = ({ children }: { children: React.ReactNode }) => {
  const { data } = useQuery(GET_TENANT_IPFS_CONFIG, {
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    const url = data?.currentTenant?.apiKeys?.ipfsGatewayUrl;
    if (url) {
      setIpfsGatewayUrl(url);
    }
  }, [data]);

  return <>{children}</>;
};
